import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import hoistStatics from 'hoist-non-react-statics';

/**
 * This HoC allows the WrappedComponent to specify refreshInterval, and refresh callback
 * as static properties of the Component, it can also receive these values as props.
 * It uses lifecycle methods to set up and tear down refresh logic which will execute the
 * "onRefresh" callback
 */
export default (WrappedComponent) => {
    class Refreshable extends Component {
        constructor(props) {
            super(props);
            this.refreshId = null;

            this.interval = WrappedComponent.refreshInterval;
            this.onRefresh = WrappedComponent.onRefresh;
        }

        componentDidMount() {
            const {
                interval = this.interval,
                onRefresh = this.onRefresh
            } = this.props;

            if (interval) {
                this.refreshId = setInterval(() => {
                    if (onRefresh) {
                        onRefresh(this.props);
                    }
                }, interval * 1000);
            }
        }

        componentWillUnmount() {
            if (this.refreshId) {
                clearInterval(this.refreshId);
            }
        }

        render() {
            return (
                <WrappedComponent {...this.props} />
            );
        }
    }

    Refreshable.propTypes = {
        interval: PropTypes.number,
        onRefresh: PropTypes.func
    };

    const mapStateToProps = ({ app: { lang } }) => ({
        lang
    });

    return connect(mapStateToProps)(hoistStatics(Refreshable, WrappedComponent));
};



// WEBPACK FOOTER //
// ./app/common/refreshable.js